import { getPackageProviderIconUrl } from 'components/shared/ppoints/PackageProviderIcon';
import { PackageProviderName } from 'data/ppoints/constants';
import styles from './ProviderLogoBadge.module.css';

export interface ProviderLogoBadgeProps {
    provider: PackageProviderName;
    className?: string;
}

export const ProviderLogoBadge: React.FC<ProviderLogoBadgeProps> = ({ provider, className }) => (
    <div className={`${styles.plate} ${className ?? ''}`} aria-hidden="true">
        <img className={styles.logo} src={getPackageProviderIconUrl(provider)} alt="" loading="lazy" />
    </div>
);
